import { Box, Button, Heading, Link, SuccessAnimation, Text } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';

export function SuccessfulActivationPage() {
    const navigate = useNavigate();

    return (
        <>
            <Heading>Aan de slag met Ksyos</Heading>
            <Box
                display="flex"
                justifyContent="center"
            >
                <SuccessAnimation size="large" />
            </Box>
            <Text>
                Vanaf nu kan je inloggen in Ksyos met wachtwoord en verificatieapp. Bekijk de instructievideo's om je
                wegwijs te maken in het Ksyos platform.
            </Text>
            <Text
                size="sm"
                textAlign="center"
            >
                <Link
                    fontWeight="bold"
                    href={'https://ksyos.nl/instructievideo'}
                    iconRight="external"
                    openInNewTab={true}
                    variant="externalLink"
                >
                    Ksyos instructievideo's
                </Link>
            </Text>
            <Text
                color="minimal"
                size="sm"
            >
                De link naar de instructievideo’s kan je ook terugvinden in de email die we zojuist hebben verstuurd.
            </Text>
            <Button
                color="secondary"
                onClick={() => navigate('/home')}
                width="full"
            >
                Log in
            </Button>
        </>
    );
}
